/* =========================================================================
   BUMPY VICE — recherche prédictive
   Interroge /search/suggest et rend la section « predictive-search ».
   ========================================================================= */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE = 220;

  function init(form) {
    if (form.dataset.predictiveReady === 'true') return;
    form.dataset.predictiveReady = 'true';

    var input = form.querySelector('[data-predictive-input]');
    var results = form.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var timer = null;
    var controller = null;
    var lastQuery = '';

    function close() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('[data-predictive-content]');
      results.innerHTML = content ? content.innerHTML : '';
      results.hidden = !results.innerHTML.trim();
      input.setAttribute('aria-expanded', String(!results.hidden));
    }

    function search(q) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url =
        '/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(render)
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;

      clearTimeout(timer);
      if (q.length < MIN_CHARS) { close(); return; }
      timer = setTimeout(function () { search(q); }, DEBOUNCE);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && results.innerHTML.trim()) results.hidden = false;
    });

    // Navigation au clavier dans la liste de suggestions.
    input.addEventListener('keydown', function (e) {
      if (results.hidden) return;
      var items = Array.prototype.slice.call(results.querySelectorAll('.predictive__item'));
      if (!items.length) return;

      var current = items.findIndex(function (i) { return i.getAttribute('aria-selected') === 'true'; });
      var next = -1;

      if (e.key === 'ArrowDown') next = (current + 1) % items.length;
      else if (e.key === 'ArrowUp') next = (current - 1 + items.length) % items.length;
      else if (e.key === 'Enter' && current > -1) { e.preventDefault(); items[current].click(); return; }
      else if (e.key === 'Escape') { close(); return; }
      else return;

      e.preventDefault();
      items.forEach(function (i) { i.setAttribute('aria-selected', 'false'); });
      items[next].setAttribute('aria-selected', 'true');
      items[next].scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-predictive-form]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
